<template>
  <div class="pa-item-badge-banner" @click.prevent="handleClickBanner">
    <div class="pa-badge-circle"><PAItemBadgeIcon :item="badge" /></div>
    <div class="text">{{count}}</div>
  </div>
</template>

<script>
import PAItemBadgeIcon from '@/components/Parts/PAItemBadgeIcon/PAItemBadgeIcon.vue'

export default {
  props : {
    badge : {
      default: null
    },

    count : {
      default: null
    }
  },

  components : {
    PAItemBadgeIcon
  },

  methods : {
    handleClickBanner(){
      this.$emit('click');
    }
  }
}
</script>

<style lang="scss">
.pa-item-badge-banner{
  padding:0 .5rem 0 0;
  background-color: #BB9D79;
  border-radius: 11px;
  height:22px;
  line-height: 22px;
  font-size: 16px;
  display: flex;
  flex-flow: row;
  cursor: pointer;
  user-select: none;

  .pa-badge-circle{
    margin:0 .3rem 0 0;
  }

  .text{
    font-size:14px;
    font-weight: bold;
  }
}
</style>